export const REGISTRATION = 1;
export const APPROVAL = 2;
export const UPDATE = 3;
